import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './Login.scss';
import Spinner from '../Spinner/Spinner';
import { postLogin } from '../../APICalls/GetRequests';

// Material UI Icons
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const LogIn = ({ setIsLoggedIn }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setLoading(true);
    const body = { username, password };

    try {
      const data = await postLogin(body);
      Cookies.set('session_key', data.token);
      Cookies.set('username', username);
      setIsLoggedIn(true);
      navigate('/');
    } catch (errorResponse) {
      if (errorResponse.error === 'user does not exist') {
        setErrorMessage('User does not exist. Please try again or create an account.');
      } else if (errorResponse.error === 'invalid username or password') {
        setErrorMessage('Invalid username or password. Please try again.');
      } else {
        setErrorMessage('An unexpected error occurred. Please try again later.');
      }
      console.error('Login error:', errorResponse);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="LogIn">
      <div className="login-box">
        <h2>Login</h2>
        <form className="login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label className="login-label" htmlFor="username">
              Username
            </label>
            <input
              className="login-input"
              type="text"
              id="username"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          {/* Password Field with visibility toggle */}
          <div className="form-group password-group">
            <label className="login-label" htmlFor="password">
              Password
            </label>
            <div className="password-wrapper">
              <input
                className="login-input"
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </button>
            </div>
          </div>

          {errorMessage && <p className="error-message">{errorMessage}</p>}

          <div className="button-container">
            <button className="submit" type="submit" disabled={loading}>
              {loading ? (
                <Spinner color="white" backgroundColor="#6200ee" />
              ) : (
                'Submit'
              )}
            </button>
            <div className="links">
              <span className="link" onClick={() => navigate('/create-account')}>
                Create an Account
              </span>
              <span className="link" onClick={() => navigate('/create-sub-user')}>
                Create Sub-Account
              </span>
              <span className="forgot-password link">Forgot Password?</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LogIn;

